import React from 'react';
import { PiTrashDuotone } from 'react-icons/pi';
import { Button } from 'rizzui';
import CustomSearchableEntities from '../../../components/forms/CustomSearchableEntities';
import CustomSelect from '../../../components/forms/CustomSelect';
import { FilterOptions } from '../../../hooks/useFilters';
import { NetworkService } from '../../../services/network/networkService';

interface NetworkSettlementsFiltersProps {
    updateFilters: (filters: any) => void
    resetFilters: (limit: any) => void
    filters: FilterOptions
    hideCommercialNetwork?: boolean
}

const monthOptions = [
    { label: 'Enero', value: 1 },
    { label: 'Febrero', value: 2 },
    { label: 'Marzo', value: 3 },
    { label: 'Abril', value: 4 },
    { label: 'Mayo', value: 5 },
    { label: 'Junio', value: 6 },
    { label: 'Julio', value: 7 },
    { label: 'Agosto', value: 8 },
    { label: 'Septiembre', value: 9 },
    { label: 'Octubre', value: 10 },
    { label: 'Noviembre', value: 11 },
    { label: 'Diciembre', value: 12 },
];

const getYearOptions = () => {
    const currentYear = new Date().getFullYear();
    return Array.from({ length: 6 }, (_, index) => {
        const year = currentYear - index;
        return { label: `${year}`, value: year };
    });
};

const NetworkSettlementsFilters: React.FC<NetworkSettlementsFiltersProps> = ({ filters, updateFilters, resetFilters, hideCommercialNetwork = false }) => {
    return (
        <>
            <CustomSelect
                id={'month'}
                label="Mes"
                isSearchable
                options={monthOptions}
                onChange={(option: any) => updateFilters({ month: option?.value ?? null })}
                value={monthOptions.find((item) => item.value === (filters.filter_filters?.month ?? new Date().getMonth() + 1))}
            />

            <CustomSelect
                id={'year'}
                label="Año"
                isSearchable
                options={getYearOptions()}
                onChange={(option: any) => updateFilters({ year: option?.value ?? null })}
                value={getYearOptions().find((item) => item.value === (filters.filter_filters?.year ?? new Date().getFullYear()))}
            />

            <CustomSelect
                id={'settlement_status'}
                label="Estado"
                isSearchable
                isClearable
                options={[
                    { label: 'Comisión', value: 'commission' },
                    { label: 'Ajuste', value: 'adjustment' },
                ]}
                onChange={(option: any) => updateFilters({ settlement_status: option?.value ?? null })}
                value={
                    filters.filter_filters?.settlement_status
                        ? [
                            { label: 'Comisión', value: 'commission' },
                            { label: 'Ajuste', value: 'adjustment' },
                        ].find((item) => item.value === filters.filter_filters?.settlement_status)
                        : null
                }
            />

            {!hideCommercialNetwork && (
                <CustomSearchableEntities
                    id="commercial_network"
                    label="Red Comercial"
                    filters={filters}
                    updateFilters={updateFilters}
                    fetchOptions={async (searchText: string | null) => {
                        const response = await (new NetworkService()).listCommercialNetworksForSelect({
                            filter_filters: {
                                search_text: searchText,
                            },
                            limit: 999999,
                            page: 1,
                        });

                        const rows = response.getResponseData()?.data ?? [];
                        return rows.map((row: any) => ({
                            value: row.commercial_network_id,
                            label: row.name,
                        }));
                    }}
                    permissions={[
                        {
                            group: 'commercial_network',
                            action: 'list_commercial_network',
                        }
                    ]}
                />
            )}

            <Button
                size="sm"
                onClick={() => resetFilters(50)}
                variant="flat"
                className="h-9 bg-gray-200/70"
            >
                <PiTrashDuotone className="me-1.5 h-[17px] w-[17px]" /> Limpiar
            </Button>
        </>
    );
};

export default NetworkSettlementsFilters;
